import type { MouseEventHandler, ReactNode } from 'react'

import { forwardRef } from 'react'

export interface BasicLinkProps {
  ariaHidden?: boolean
  ariaLabelledby?: string
  children?: ReactNode
  className?: string
  href?: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
  tabIndex?: number
  newTab?: boolean
}

const BasicLink = forwardRef<HTMLAnchorElement, BasicLinkProps>(
  (
    {
      ariaHidden,
      ariaLabelledby,
      className,
      children,
      href,
      onClick,
      tabIndex,
      newTab,
    },
    ref,
  ) => {
    const rest = {
      ...(ariaHidden && { 'aria-hidden': ariaHidden }),
      ...(ariaLabelledby && { 'aria-labelledby': ariaLabelledby }),
      ...(href && { href }),
      ...(newTab && { target: '_blank', rel: 'noopener noreferrer' }),
    }

    return (
      <a
        className={className}
        onClick={onClick}
        ref={ref}
        tabIndex={tabIndex}
        {...rest}
      >
        {children}
      </a>
    )
  },
)

BasicLink.displayName = 'BasicLink'

export default BasicLink
